var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57043 19.32C9.38043 19.32 9.19043 19.25 9.04043 19.1L2.97043 13.03C2.68043 12.74 2.68043 12.26 2.97043 11.97L9.04043 5.9C9.33043 5.61 9.81043 5.61 10.1004 5.9C10.3904 6.19 10.3904 6.67 10.1004 6.96L4.56043 12.5L10.1004 18.04C10.3904 18.33 10.3904 18.81 10.1004 19.1C9.96043 19.25 9.76043 19.32 9.57043 19.32Z",
    fill: "#2A2B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 13.25H3.66992C3.25992 13.25 2.91992 12.91 2.91992 12.5C2.91992 12.09 3.25992 11.75 3.66992 11.75H20.4999C20.9099 11.75 21.2499 12.09 21.2499 12.5C21.2499 12.91 20.9099 13.25 20.4999 13.25Z",
    fill: "#2A2B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.897c5ba64a49b249381996a969e81ef7.svg";
export { ForwardRef as ReactComponent };